import home from "../assets/images/layouts/sidebar-icons/home/home.svg";
import gear from "../assets/images/layouts/sidebar-icons/settings/gear.svg";
import roles from "../assets/images/layouts/sidebar-icons/roles/user.svg";
import category from "../assets/images/layouts/sidebar-icons/category/category.svg";
import products from "../assets/images/layouts/sidebar-icons/products/product.svg";
import contacts from "../assets/images/layouts/sidebar-icons/contact/contacts.svg";
import for_user from "../assets/images/layouts/sidebar-icons/for-user/for_user.svg";
import services from "../assets/images/layouts/sidebar-icons/services/services.svg";
import orders from "../assets/images/layouts/sidebar-icons/orders/orders.svg";
import video from "../assets/images/layouts/sidebar-icons/video/video.svg";
import banner from "../assets/images/layouts/sidebar-icons/pages/pages.svg";
import notification from "../assets/images/layouts/sidebar-icons/notification/notification-bell.svg";
import gallery from "../assets/images/layouts/sidebar-icons/gallery/instagram-gallery.svg";

import home_active from "../assets/images/layouts/sidebar-icons/home/home_active.svg";
import gear_active from "../assets/images/layouts/sidebar-icons/settings/gear_active.svg";
import roles_active from "../assets/images/layouts/sidebar-icons/roles/user_active.svg";
import category_active from "../assets/images/layouts/sidebar-icons/category/category_active.svg";
import products_active from "../assets/images/layouts/sidebar-icons/products/product_active.svg";
import contacts_active from "../assets/images/layouts/sidebar-icons/contact/contacts_active.svg";
import for_user_active from "../assets/images/layouts/sidebar-icons/for-user/for_user_active.svg";
import services_active from "../assets/images/layouts/sidebar-icons/services/services_active.svg";
import orders_active from "../assets/images/layouts/sidebar-icons/orders/orders_active.svg";
import video_active from "../assets/images/layouts/sidebar-icons/video/video_active.svg";
import banner_active from "../assets/images/layouts/sidebar-icons/pages/pages_active.svg";
import notification_active from "../assets/images/layouts/sidebar-icons/notification/notification-bell-active.svg";
import gallery_active from "../assets/images/layouts/sidebar-icons/gallery/instagram-gallery-active.svg";

const sidebar_icons = [
  {
    id: 0,
    icon: home,
    active_icon: home_active,
  },
  {
    id: 1,
    icon: roles,
    active_icon: roles_active,
  },
  {
    id: 2,
    icon: gear,
    active_icon: gear_active,
  },
  {
    id: 3,
    icon: category,
    active_icon: category_active,
  },
  {
    id: 4,
    icon: products,
    active_icon: products_active,
  },
  {
    id: 7,
    icon: services,
    active_icon: services_active,
  },
  {
    id: 8,
    icon: orders,
    active_icon: orders_active,
  },
  {
    id: 5,
    icon: contacts,
    active_icon: contacts_active,
  },
  {
    id: 6,
    icon: for_user,
    active_icon: for_user_active,
  },
  {
    id: 7,
    icon: video,
    active_icon: video_active,
  },
  {
    id: 8,
    icon: banner,
    active_icon: banner_active,
  },
  {
    id: 9,
    icon: notification,
    active_icon: notification_active,
  },
  {
    id: 10,
    icon: gallery,
    active_icon: gallery_active,
  },
];

export default sidebar_icons;
